"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./app.interface"), exports);
__exportStar(require("./utils.interface"), exports);
__exportStar(require("./api.interface"), exports);
__exportStar(require("./common.interface"), exports);
__exportStar(require("./organization.interface"), exports);
__exportStar(require("./loyalty.interface"), exports);
__exportStar(require("./customer-loyalty.interface"), exports);
__exportStar(require("./mail.interface"), exports);
__exportStar(require("./address.interface"), exports);
__exportStar(require("./customer.interface"), exports);
__exportStar(require("./geocoding.interface"), exports);
__exportStar(require("./brand.interface"), exports);
__exportStar(require("./auth.interface"), exports);
__exportStar(require("./supplier.interface"), exports);
__exportStar(require("./schedule.interface"), exports);
__exportStar(require("./base.interface"), exports);
__exportStar(require("./payment-method.interface"), exports);
__exportStar(require("./payment.interface"), exports);
__exportStar(require("./cart.interface"), exports);
__exportStar(require("./service-stats.interface"), exports);
__exportStar(require("./printer.interface"), exports);
__exportStar(require("./contract.interface"), exports);
__exportStar(require("./timesheet.interface"), exports);
__exportStar(require("./clocking-in.interface"), exports);
__exportStar(require("./kitchen-area.interface"), exports);
__exportStar(require("./payment.interface"), exports);
__exportStar(require("./fiscal.interface"), exports);
